import * as lockersDry from 'app/mocks/data/machines/all/lockersDry'

export const lockerDryDiagnostic1 = {
    machine: {
        id: lockersDry.lockerDry1.id,
        type: lockersDry.lockerDry1.category,
    },
    internet: {
        is_online: true,
        last_loss_connection: '2022-12-27 08:26:49.219717',
        last_heartbeat_connection: '2022-12-27 08:26:49.219717',
    },
}

export const lockerDryDiagnostic2 = {
    machine: {
        id: lockersDry.lockerDry2.id,
        type: lockersDry.lockerDry2.category,
    },
    internet: {
        is_online: true,
        last_loss_connection: '2022-12-27 08:26:49.219717',
        last_heartbeat_connection: '2022-12-27 08:26:49.219717',
    },
}

export const lockerDryDiagnostic3 = {
    machine: {
        id: lockersDry.lockerDry3.id,
        type: lockersDry.lockerDry3.category,
    },
    internet: {
        is_online: true,
        last_loss_connection: '2022-12-27 08:26:49.219717',
        last_heartbeat_connection: '2022-12-27 08:26:49.219717',
    },
}
